import { defineAsyncComponent, type Component } from 'vue'

import { ApplicationAdditionType } from '@/services/application'

const ApplicationAdditionRequestPayoutDate = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestPayoutDate.vue'),
)
const ApplicationAdditionRequestDocument = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestDocument.vue'),
)
const ApplicationAdditionRequestApartmentNbrBRF = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestApartmentNbrBRF.vue'),
)
const ApplicationAdditionRequestHomeInsurance = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestHomeInsurance.vue'),
)
const ApplicationAdditionRequestHousingAssociation = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestHousingAssociation.vue'),
)
const ApplicationAdditionRequestTopupPurpose = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestTopupPurpose.vue'),
)
const ApplicationAdditionRequestRealtorInformation = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestRealtorInformation.vue'),
)
const ApplicationAdditionRequestPlannedCashDisbursement = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestPlannedCashDisbursement.vue'),
)
const ApplicationAdditionRequestPlannedRepayMortgage = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestPlannedRepayMortgage.vue'),
)
const ApplicationAdditionRequestMoneySource = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestMoneySource.vue'),
)
const ApplicationAdditionRequestBankAccount = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestBankAccount.vue'),
)
const ApplicationAdditionRequestLoans = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestLoans.vue'),
)

const ApplicationAdditionRequestCapitalIncome = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestCapitalIncome.vue'),
)
const ApplicationAdditionRequestUpdateParties = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestUpdateParties.vue'),
)
const ApplicationAdditionRequestPropertySales = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestPropertySales.vue'),
)
const ApplicationAdditionRequestKyc = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestKyc.vue'),
)
const ApplicationAdditionRequestUnsecuredLoan = defineAsyncComponent(
  () => import('./components/ApplicationAdditionRequestUnsecuredLoan.vue'),
)

export const applicationAdditionRequestComponents = {
  [ApplicationAdditionType.documentAmortizationProof]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentAnnualReportBRF]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentApartmentRegister]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentAuditorCertificate]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentBlancoLoanDocumentation]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentBrokerAssignment]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentDeedOfGift]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentDepositAgreement]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentDivorcePapers]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentEconomicPlan]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentEnergyDeclaration]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentEstateDivision]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentFinalInspection]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentFinancialPlan]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentGreenRenovation]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentInventoryOfEstate]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentInvoiceFinal]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentLoanPurposeDocumentation]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentMoneySource]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentPaperMortgageDeeds]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentPensionProof]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentPension]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentValuation]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentPowerOfAttorney]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentPrenuptialAgreement]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentPromissoryNote]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentPropertyDescription]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentPurchaseContract]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentRetaxation]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentSalesContract]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentTestament]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.documentIncome]: ApplicationAdditionRequestDocument,
  [ApplicationAdditionType.apartmentNbrBRF]: ApplicationAdditionRequestApartmentNbrBRF,
  [ApplicationAdditionType.homeInsurance]: ApplicationAdditionRequestHomeInsurance,
  [ApplicationAdditionType.housingAssociation]: ApplicationAdditionRequestHousingAssociation,
  [ApplicationAdditionType.bankAccount]: ApplicationAdditionRequestBankAccount,
  [ApplicationAdditionType.loans]: ApplicationAdditionRequestLoans,
  [ApplicationAdditionType.payoutDate]: ApplicationAdditionRequestPayoutDate,
  [ApplicationAdditionType.plannedCashDisbursement]: ApplicationAdditionRequestPlannedCashDisbursement,
  [ApplicationAdditionType.plannedRepayMortgage]: ApplicationAdditionRequestPlannedRepayMortgage,
  [ApplicationAdditionType.moneySource]: ApplicationAdditionRequestMoneySource,
  [ApplicationAdditionType.updateParties]: ApplicationAdditionRequestUpdateParties,
  [ApplicationAdditionType.topupPurpose]: ApplicationAdditionRequestTopupPurpose,
  [ApplicationAdditionType.propertySales]: ApplicationAdditionRequestPropertySales,
  [ApplicationAdditionType.bridgeLoan]: ApplicationAdditionRequestUnsecuredLoan,
  [ApplicationAdditionType.depositLoan]: ApplicationAdditionRequestUnsecuredLoan,
  [ApplicationAdditionType.realtorInformation]: ApplicationAdditionRequestRealtorInformation,
  [ApplicationAdditionType.capital]: ApplicationAdditionRequestCapitalIncome,
  [ApplicationAdditionType.kyc]: ApplicationAdditionRequestKyc,
} satisfies Record<ApplicationAdditionType, Component>
